export const IMAGE_RESOLUTIONS = {
  HD: 'HD',
  '4K': '4K',
  '8K': '8K',
} as const;
type IMAGE_RESOLUTIONS_KEYS = keyof typeof IMAGE_RESOLUTIONS;
export type TYPE_IMAGE_RESOLUTIONS = (typeof IMAGE_RESOLUTIONS)[IMAGE_RESOLUTIONS_KEYS];

export const EXPORT_OPTIONS = {
  PDF: 'pdf',
  PNG: 'png',
} as const;
type EXPORT_OPTIONS_KEYS = keyof typeof EXPORT_OPTIONS;
export type TYPE_EXPORT_OPTIONS = (typeof EXPORT_OPTIONS)[EXPORT_OPTIONS_KEYS];
